<template>
  <div>
    <div v-if="games" class="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4 mt-5 mb-5">
      <Card
          v-for="(game, index) in games"
          :img="game.banner"
          imaClass="rounded-md"
          overlay
          titleClass="2xl:pb-14"
          noborder
          body-class="m-0"
          :className="selectedGames.includes(game.game) ? 'ratio ratio-16x9 rounded-lg overlay-selected' : 'ratio ratio-16x9 rounded-lg'"
      >
        <Badge v-if="findCount(game.game)" :label="findCount(game.game)" badgeClass="bg-primary-500 text-white ms-2 mt-2"/>
        <div class="m-0">
          <Button
              :text="game.game"
              link="#"
              :btnClass="selectedGames.includes(game.game) ? 'btn rounded-b-lg rounded-t-none w-full bottom-0 absolute p-2 text-white bg-pink-700' : 'btn rounded-b-lg rounded-t-none w-full bottom-0 absolute p-2 text-white bg-black-500/50'"
              icon="iconamoon:check-bold"
              iconPosition="right"
              :iconClass="selectedGames.includes(game.game) ? 'visible' : 'hidden'"
          >

          </Button>
          <input class="form-check-input select-game-checkbox" type="checkbox" :value="game.game"
                 v-model="selectedGames" @change="changeGamePreferences">
        </div>
      </Card>
    </div>
    <GamesSkeleton v-else></GamesSkeleton>
    <Button
        icon="heroicons-outline:newspaper"
        :text="$t('message.show_orders')"
        btnClass="btn-primary rounded-[999px]"
        iconPosition="right"
        @click="showOrders"
    />
  </div>
</template>

<script>
import Card from "@/components/Card/index.vue";
import Button from "@/components/Button/index.vue";
import {Icon} from "@iconify/vue";
import {useUserStore} from "@/stores/user";
import {useConfigStore} from "@/stores/config";
import {computed, ref} from "vue";
import {useRouter} from "vue-router";
import {useToast} from "vue-toastification";
import GamesSkeleton from "@/components/Skeleton/Games.vue";
import {useI18n} from "vue-i18n";
import {useThemeSettingsStore} from "@/stores/themeSettings.js";
import Badge from "@/components/Badge/index.vue";
import {useOrdersStore} from "@/stores/orders.js";

export default {
  components: {
    Badge,
    GamesSkeleton,
    Card,
    Button,
    Icon
  },
  setup() {
    const ordersStore = useOrdersStore();
    const userStore = useUserStore()
    const themeSettings = useThemeSettingsStore();
    const configStore = useConfigStore()
    const router = useRouter()
    const toast = useToast();
    const selectedGames = ref(userStore.getCurrencyBuyGamePreferences);
    const {t, locale} = useI18n({useScope: 'global'})
    const games = computed(() => {
      return configStore.getCurrencyGames
    })
    const gamePreferences = computed(() => {
      return userStore.getCurrencyBuyGamePreferences
    })

    function changeGamePreferences() {
      userStore.setCurrencyBuyGamePreferences(selectedGames.value)
    }

    function showOrders() {
      if (userStore.getCurrencyBuyGamePreferences.length) {
        router.push({name: 'currency-buy-orders'})
      } else {
        toast.warning(t('message.select at least one game'), {
          timeout: 3000,
          rtl: themeSettings.direction,
          toastClassName: "!mr-0 !ml-auto",
        });
      }
    }
    const gameCounts = ref({});
    async function getCurrencyOrders() {
      await ordersStore.action_getCurrencyBuyActiveHotOrders()
      ordersStore.getCurrencyBuyOrders.forEach(order => {
        const game = order.game;
        if (game in gameCounts.value) {
          gameCounts.value[game]++;
        } else {
          gameCounts.value[game] = 1;
        }
      });
    }

    function findCount(game) {
      if (gameCounts.value[game]) {
        return (gameCounts.value[game]).toString()
      } else {
        return ""
      }
    }

    getCurrencyOrders();

    return {
      games,
      selectedGames,
      gamePreferences,
      changeGamePreferences,
      showOrders,
      findCount
    }
  }
};
</script>

<style>
.ratio-16x9 {
  --bs-aspect-ratio: calc(9 / 16 * 100%);
}

.ratio {
  position: relative;
  width: 100%;
}

.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}

.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.select-game-checkbox {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 999;
  cursor: pointer;
}
</style>
